export default "__VITE_ASSET__389f5bca__"